var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"gaia-link"},_vm._l((_vm.gaiaLinks),function(link,index){return _c('li',{key:index},[(link != null && link.url != null)?_c('a',{attrs:{"href":link.url,"target":"_blank"}},[_vm._v(_vm._s(link.label))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }